import { LOCATION_CHANGE, push } from 'connected-react-router';

import { createMiddleware } from '../../../shared/redux';
import { match } from '../../../shared/utils/match';
import { ROUTES } from '../auth.constants';
import * as AuthService from '../auth-service';
import {
    acceptSignOut,
    rejectSignOut,
    SIGN_OUT, SIGN_OUT_ACCEPTED, SIGN_OUT_REJECTED,
    signOut,
} from './sign-out-state';
import {
    resetSignIn,
} from '../sign-in/sign-in.state';

export const signOutMiddleware = createMiddleware({
    [LOCATION_CHANGE]: match((_, action) => action.payload.location.pathname, {
        [ROUTES.SIGN_OUT]: () => signOut(),
    }),

    [SIGN_OUT]: () => (
        AuthService.signOut()
            .then(() => acceptSignOut())
            .catch(error => rejectSignOut({ error }))
    ),
    [SIGN_OUT_ACCEPTED]: () => [resetSignIn(), push(ROUTES.SIGN_IN)],
    [SIGN_OUT_REJECTED]: () => [resetSignIn(), push(ROUTES.SIGN_IN)],
});
